import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { fetchActivityItems } from '../../../utils'

/*
const sampleDetail = {
  index: 23,
  count: 99,

  comment: '',
  source: '114.234.248.164 中国-北京-北京',

  rows: [{
    icon: 'name',
    name: '姓名',
    value: '张强'
  }, {
    icon: 'mail',
    name: '邮箱',
    value: 'abcabc@defdefff.com'
  }, {
    icon: 'phone',
    name: '手机',
    value: '12311112222'
  }, {
    icon: 'org',
    name: '机构名称',
    value: '海淀社工'
  }, {
    icon: 'comment',
    name: '有什么想和我叨叨的',
    content: '为一个临终关爱的患晚期肺癌的老人，拍一个宣传片，没有宣传渠道和资源，只有几个屌丝社工和一些怀揣梦想的大学生志愿者，你们能施以援手吗？'
  }, {
    icon: 'source',
    name: '来源',
    value: '114.234.248.164 中国-北京-北京'
  }, {
    name: 'name',
    value: 'value'
  }, {
    name: 'name',
    content: '为一个临终关爱的患晚期肺癌的老人，拍一个宣传片，没有宣传渠道和资源，只有几个屌丝社工和一些怀揣梦想的大学生志愿者，你们能施以援手吗？'
  }]
}
*/

const state = {
  index: 0,
  count: 0,
  is_pay_info: false,
  amount: 0.00,
  status: '',
  rows: []
}

const actions = {
  [aTypes.ACTIVITY_GET_FEEDBACK_DETAIL] ({ commit }, { contactId, activityId, signupId }) {
    commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_FEEDBACK_DETAIL, loading: true })
    api.activity.getFeedbackDetail({
      success (res) {
        const body = res.body
        const detail = {
          index: body.position ? body.position.current : '?',
          count: body.position ? body.position.total : '?',

          is_pay_info: body.is_pay_info,
          amount: body.amount,
          status: {
            success: body.status === 'paid',
            channel: body.pay_channel // '微信支付'
          },

          rows: fetchActivityItems(body.form.form_items, body.data)
        }
        commit(mTypes.ACTIVITY_SET_FEEDBACK_DETAIL, detail)
        commit(mTypes.SET_NAV_TITLE, body.form.title)
        commit(mTypes.SET_PAGINATION, {
          prevTo: body.prev_record_id ? {
            path: '/main/activity/feedback-detail',
            query: {
              contactId,
              activityId,
              signupId: body.prev_record_id
            }
          } : null,
          nextTo: body.next_record_id ? {
            path: '/main/activity/feedback-detail',
            query: {
              contactId,
              activityId,
              signupId: body.next_record_id
            }
          } : null
        })
        commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_FEEDBACK_DETAIL, loading: false })
      },
      commit
    }, { contactId, activityId, signupId })
  }
}

const mutations = {
  [mTypes.ACTIVITY_SET_FEEDBACK_DETAIL] (state, detail) {
    state.index = detail.index
    state.count = detail.count
    state.is_pay_info = detail.is_pay_info
    state.amount = detail.amount
    state.status = detail.status
    state.rows = detail.rows
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/activity/feedbackDetail.js